<template>
    <a-modal :visible="visible" title="Unggah Master Data SFC" @cancel="handleModalCancel" width="70%"
        :destroy-on-close="true">

        <template #footer>
            <AButton @click="handleModalCancel">Batal</AButton>
            <AButton key="submit" type="primary" :loading="state.loading" @click="handleSubmitOk">Submit</AButton>
        </template>

        <AForm ref="formRef" class="myform" :model="state.form" :rules="state.rules" @submit.prevent="btnUploadFile()"
            :wrapper-col="{ span: 14 }" :scroll-to-first-error="true">

            <!-- upload documen -->
            <a-row class="form-row">
                <a-col :sm="24">
                    <a-form-item label="Unggah Dokumen" label-align="left" :label-col="{ sm: { span: 4 } }"
                        :wrapper-col="{ sm: { span: 24 - 4 } }" has-feedback>
                        <a-input type="file" required
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            @change="onFileChange"></a-input>
                    </a-form-item>
                </a-col>
            </a-row>

            <a-row class="form-row mb-4">
                <ACol :sm="4" />
                <a-col :sm="20">
                    <ASpace>
                        <a-button type="primary" html-type="submit" :loading="state.form.loading">Upload</a-button>
                        <AButton @click="btnDownloadTemplate()" :loading="state.loadingTemplate">Unduh Template
                        </AButton>
                    </ASpace>
                </a-col>
            </a-row>
        </AForm>

        <AAlert v-if="errorMessage" type="error" :message="errorMessage" banner closable @close="errorMessage = null" />

        <br>

        <MdTable :columns="state.columns" :data-source="state.data" row-key="code" :row-selection="rowSelection"
            size="small" :scroll="{ x: 'calc(700px + 80%)', y: 600 }" :loading="state.loading">
            <template #tags="{ record }">
                <a-tag :color="record.errors.length == 0 ? 'green' : 'volcano'">
                    <template #icon>
                        <template v-if="record.errors.length == 0">
                            <CheckCircleOutlined /> Ya
                        </template>
                        <template v-else>
                            <APopover trigger="click">
                                <template #content>
                                    <AList size="small" :data-source="record.errors">
                                        <template #renderItem="{ item }">
                                            <AListItem>{{ item }}</AListItem>
                                        </template>
                                    </AList>
                                </template>
                                <CloseCircleOutlined /> Tidak
                            </APopover>
                        </template>
                    </template>
                </a-tag>
            </template>
            <template #level_wilayah="{ record }">
                <span>
                    {{
                        record.level_wilayah === 0 ? '0 - All Area' :
                            record.level_wilayah === 1 ? '1 - Provinsi' :
                                record.level_wilayah === 2 ? '2 - Group Wilayah' :
                                    '-'
                    }}
                </span>
            </template>
            <template #wilayahColumn="{ record }">
                <span>
                    <template v-if="record.level_wilayah === 0">
                        -
                    </template>

                    <template v-else>
                        <!-- Jika array dan lebih dari 1 -->
                        <template v-if="Array.isArray(record.wilayah_id) && record.wilayah_id.length > 1">
                            {{ record.group_wilayah }} - {{ record.group_wilayah_name }}
                            (
                            <span v-for="(id, i) in record.wilayah_id" :key="i">
                                {{ id }} - {{ record.wilayah_name?.[i] || '-' }}
                                <span v-if="i < record.wilayah_id.length - 1">, </span>
                            </span>
                            )
                        </template>

                        <!-- Jika single value -->
                        <template v-else>
                            {{ Array.isArray(record.wilayah_id) ? record.wilayah_id[0] : record.wilayah_id || '-' }}
                            <span v-if="record.wilayah_name">
                                - {{ Array.isArray(record.wilayah_name) ? record.wilayah_name[0] : record.wilayah_name
                                }}
                            </span>
                        </template>
                    </template>
                </span>
            </template>
        </MdTable>

        <AModal v-model:visible="state.result.isShow" title="Result" @cancel="handleModalCancel"
            @ok="handleModalCancel">
            <template #footer>
                <AButton key="back" type="primary" @click="handleShowCancel">OK</AButton>
            </template>
            <AAlert type="success" :message="`Sukses: ${state.result.valid}`"></AAlert>
            <AAlert type="error">
                <template #message>
                    {{ `Gagal: ${state.result.failed}` }}
                    <a-tree :tree-data="state.result.data" default-expand-all />
                </template>
            </AAlert>
        </AModal>

    </a-modal>
</template>

<script>
import {
    defineComponent,
    reactive,
    ref,
    computed,
} from 'vue'
import apiClient from '@/services/axios'
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons-vue'
import { Modal, message } from 'ant-design-vue'
import moment from 'moment'
import {
    hasRoles,
} from '@/helpers'

export default defineComponent({
    components: {
        CheckCircleOutlined,
        CloseCircleOutlined,
    },
    props: {
        visible: [Boolean],
        item: {
            type: Object,
            default: () => ({
                id: null,
            }),
        },
    },
    emits: ['btnUploadFileConversionPoint', 'update:visible'],
    setup(props, { emit }) {
        const errorMessage = ref()

        const formRef = ref();

        const state = reactive({
            columns: [
                {
                    title: 'Valid?',
                    dataIndex: 'valid',
                    slots: {
                        customRender: 'tags',
                    },
                    width: 80,
                },
                {
                    title: 'Bulan',
                    dataIndex: 'month',
                    width: 80,
                },
                {
                    title: 'Level Wilayah',
                    dataIndex: 'level_wilayah',
                    slots: { customRender: 'level_wilayah' },
                },
                {
                    title: 'Wilayah',
                    dataIndex: 'wilayah_id',
                    slots: { customRender: 'wilayahColumn' },
                },
                // {
                //     title: 'Wilayah ID',
                //     dataIndex: 'wilayah_id',
                // },
                // {
                //     title: 'Nama Wilayah',
                //     dataIndex: 'wilayah_name',
                // },
                // {
                //     title: 'Level',
                //     dataIndex: 'level',
                // },
                // {
                //     title: 'Entitas',
                //     dataIndex: 'entitas',
                // },
                {
                    title: 'Target Hari Kerja',
                    dataIndex: 'target_hari_kerja',
                },
                {
                    title: 'Target Visit',
                    dataIndex: 'target_visit',
                },
                // {
                //     title: 'Target NOO',
                //     dataIndex: 'target_noo',
                // },
                {
                    title: 'Action',
                    dataIndex: 'target_action',
                },
            ],
            endpoint: {
                current: `/api/atsalesman/salesman-target-sfc/upload`,
                template: `/api/atsalesman/salesman-target-sfc/sample-upload`,
            },
            data: [],
            loading: false,
            meta: {
                per_page: 10,
                page: 1,
                total: 0,
            },
            selectedRowKeys: [],
            selectedRows: [],
            result: {
                isShow: false,
                data: [],
                valid: 0,
                failed: 0,
            },
            form: {
                loading: false,
                files: null,
                file: null,
            },
        })

        const handleModalCancel = () => {
            emit('update:visible', false)
        }

        const onFileChange = (e) => {
            var files = e.target.files || e.dataTransfer.files
            if (!files.length) return
            state.form.file = files[0]
        }

        const rowSelection = computed(() => {
            return {
                selectedRowKeys: state.selectedRowKeys,
                onChange: (selectedRowKeys, selectedRows) => {
                    state.selectedRowKeys = selectedRowKeys
                    state.selectedRows = selectedRows
                },
                getCheckboxProps: record => ({
                    disabled: !record.valid,
                }),
            }
        })

        const btnUploadFile = async () => {
            // validation form
            await formRef.value.validate()
                .catch(() => { });

            state.form.loading = true

            const form_data = new FormData()

            form_data.append('datasample_id', props.item.id)
            form_data.append('file', state.form.file)

            apiClient
                .post(state.endpoint.current, form_data)
                .then(({ data }) => {
                    data.forEach((item, index) => {
                        item.code = index
                    })

                    state.data = data
                })
                .catch(async error => {
                    errorMessage.value = null

                    if (error.response && error.response.status !== 500) {
                        const { status, statusText } = error.response
                        const message = JSON.parse(await error.response.data.text()).message
                        errorMessage.value = `Kode error ${status}, ${statusText} : ${message}`
                    }

                    if (error.response && error.response.status === 500) {
                        const { status, statusText } = error.response
                        const message = error.response.data.message
                        errorMessage.value = `Kode error ${status}, ${statusText} : ${message}`
                    }

                    message.error('Gagal mengungah!')
                })
                .finally(() => {
                    state.form.loading = false
                })
        }

        const handleSubmitOk = async () => {
            errorMessage.value = null
            state.loading = true

            apiClient
                .post(state.endpoint.current, {
                    datasample_id: props.item.id,
                    simpan: state.selectedRows,
                })
                .then(({ data }) => {
                    if (Array.isArray(data) && data.length === 0) {
                        message.warning('Tidak ada data!, pastikan sudah memilih datanya')
                        return
                    }

                    state.result.isShow = true
                    state.result.data = []
                    state.result.valid = 0
                    state.result.failed = 0

                    data.forEach((item, idx) => {
                        if (item.success) {
                            state.result.valid++
                        } else {
                            state.result.failed++
                            const branch = {}
                            state.result.data.push(branch)
                            branch.title = 'Baris ' + (idx + 1)
                            branch.key = idx
                            branch.children = []
                            if (item.errors.length) {
                                item.errors.forEach((v, i) => {
                                    branch.children.push({
                                        title: v,
                                        key: `${idx}-${i}`,
                                    })
                                })
                            }
                        }
                    })

                    emit('success', data)
                })
                .catch(async error => {
                    errorMessage.value = null
                    if (error.response) {
                        const { status, statusText } = error.response
                        const message = error.response.data.message
                        errorMessage.value = `Kode error ${status}, ${statusText} : ${message}`
                    }
                })
                .finally(() => {
                    state.loading = false
                    state.selectedRowKeys = []
                    state.selectedRows = []
                })
        }

        const btnDownloadTemplate = async () => {
            state.loadingTemplate = true

            apiClient.get(state.endpoint.template, {
                // params: {
                //     _export: 'xls',
                // },
                responseType: 'blob',
                headers: {},
            }).then(response => {
                if (response === undefined) {
                    errorMessage.value = `Kode error 500, No response from server`
                    return
                }
                const url = URL.createObjectURL(
                    new Blob([response.data], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    }),
                )
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', `Master-Target-SFC_${moment().format('DDMMYY_HHmm')}.xlsx`)
                document.body.appendChild(link)
                link.click()
            })
                .catch(async error => {
                    errorMessage.value = null
                    if (error.response) {
                        const { status, statusText } = error.response
                        const message = JSON.parse(await error.response.data.text()).message
                        errorMessage.value = `Kode error ${status}, ${statusText} : ${message}`
                    }
                })
                .finally(() => {
                    state.loadingTemplate = false
                })
        }

        const handleShowCancel = () => {
            state.result.isShow = false
            handleModalCancel()
        }

        return {
            errorMessage,
            state,
            formRef,
            btnUploadFile,
            handleSubmitOk,
            handleModalCancel,
            onFileChange,
            rowSelection,
            btnDownloadTemplate,
            handleShowCancel,
            // only variable roles
            hasRoles,
        }
    },
})
</script>

<style lang="scss" scoped>
@import '@/assets/scss/form.scss';
</style>
